// Forked from https://github.com/blocka/vue-rule-builder
import { RuleBuilder as acRuleBuilder } from 'vue-rule-builder'
import 'vue-rule-builder/dist/styles.css'

acRuleBuilder.name = 'ac-rule-builder'

export default acRuleBuilder
